import { isWalkthroughBuild } from './liveWrites.js';

/* Does this form file a REAL ticket? (S08 part A, Grant 2026-10-28.)
 *
 * The normal build: every form does. It goes to the API, gets a server number, and can carry
 * files, a follow-up link and "for someone else". (It does NOT email its desk team: only the
 * Claude seat form emails IT on create today. That is a decision for Grant, in BACKLOG.)
 * The walkthrough build: no form does. Every form files to the demo store in this browser, so a
 * demo session never sends anything.
 *
 * This replaced the per-form `server: true` flags. Every screen that asks "real or demo?" for a
 * form asks HERE, so the answer cannot differ between the store and the form. */
export const filesForReal = (type, { walkthrough = isWalkthroughBuild() } = {}) => Boolean(type) && !walkthrough;
